/* eslint-disable menti-react/filename-convention--jsx */
import React, {
  useState,
  type FocusEvent,
  type FocusEventHandler,
  type ReactNode,
} from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import type { BoxT } from '../box';
import { CharacterCount, CharacterCountWrap } from '../character-count';

interface FocusabledCharacterCountT extends BoxT {
  maxLength?: number | undefined;
  value: string;
  render: (arg0: {
    value: string;
    onFocus: FocusEventHandler;
    onBlur: FocusEventHandler;
  }) => ReactNode;
  onFocus?: FocusEventHandler;
  onBlur?: FocusEventHandler;
  multiline?: boolean;
  iconTrailing?: boolean;
}

/**
 * @deprecated
 */

export default function FocusableCharacterCount({
  id,
  render,
  maxLength,
  value,
  multiline,
  onFocus,
  onBlur,
  iconTrailing,
  className,
  ...rest
}: FocusabledCharacterCountT) {
  const [inFocus, setInFocus] = useState(false);

  const handleFocus = (e: FocusEvent) => {
    setInFocus(true);
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e: FocusEvent) => {
    setInFocus(false);
    if (onBlur) onBlur(e);
  };

  return (
    <CharacterCountWrap
      multiline={multiline}
      className={clsx(['w-full', 'flex-1'], className)}
      {...rest}
    >
      {render({
        onFocus: handleFocus,
        onBlur: handleBlur,
        value,
      })}

      {maxLength && (
        <CharacterCount
          maxLength={maxLength}
          value={value}
          multiline={multiline}
          iconTrailing={iconTrailing}
          id={id}
          className={clsx([!inFocus && 'hidden'])}
        />
      )}
    </CharacterCountWrap>
  );
}
